import TerminatedGramWarning from './TerminatedGramWarning';

export default TerminatedGramWarning;
